import {APP_PREFIX_PATH} from '@/constants/route.constant'
import {NAV_ITEM_TYPE_ITEM, NAV_ITEM_TYPE_TITLE,} from '@/constants/navigation.constant'
import {Permissions} from "@/constants/app.constant";

const culturalNavigationConfig = [
    {
        key: 'cultural',
        path: '',
        title: 'فرهنگی',
        translateKey: 'فرهنگی',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        permissions: [Permissions.cultural.value],
        subMenu: [
            {
                key: 'cities',
                path: `${APP_PREFIX_PATH}/cities`,
                title: 'شهرها',
                translateKey: 'شهرها',
                icon: 'FaCity',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.cities.value],
                subMenu: [],
            },
            {
                key: 'banners/menu',
                path: `${APP_PREFIX_PATH}/banners`,
                title: 'بنرها',
                translateKey: 'بنرها',
                icon: 'TfiLayoutSliderAlt',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.banners.value],
                subMenu: [
                    {
                        key: 'banners',
                        path: `${APP_PREFIX_PATH}/banners`,
                        title: 'بنرها',
                        translateKey: 'بنرها',
                        icon: 'TfiLayoutSliderAlt',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.banners.value],
                        subMenu: [],
                    },
                    {
                        key: 'banners/places',
                        path: `${APP_PREFIX_PATH}/banners/places`,
                        title: 'مکان‌های بنرها',
                        translateKey: 'مکان‌های بنرها',
                        icon: 'TfiLayoutSlider',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.bannersPlaces.value],
                        subMenu: [],
                    },
                ]
            },
        ]
    },
    {
        key: 'travel',
        path: `${APP_PREFIX_PATH}/travel`,
        title: 'سفر',
        translateKey: 'سفر',
        icon: 'TcRoadTrip',
        type: NAV_ITEM_TYPE_TITLE,
        permissions: [Permissions.cultural.travel.value],
        subMenu: [
            /*{
                key: 'travel/flights',
                path: `${APP_PREFIX_PATH}/travel/flights`,
                title: 'پروازها',
                translateKey: 'پروازها',
                icon: 'IoAirplane',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.travel.flights.value],
                subMenu: [],
            },*/
            {
                key: 'travel/credits',
                path: `${APP_PREFIX_PATH}/travel/credits`,
                title: 'اعتبارات',
                translateKey: 'اعتبارات',
                icon: 'FaRegCreditCard',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.travel.credits.value],
                subMenu: [],
            },
            {
                key: 'travel/credits/usages',
                path: `${APP_PREFIX_PATH}/travel/credits/usages`,
                title: 'مصرف اعتبارات',
                translateKey: 'مصرف اعتبارات',
                icon: 'FaRegCreditCard',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.travel.creditsUsages.value],
                subMenu: [],
            },
            {
                key: 'travel/wallet/records',
                path: `${APP_PREFIX_PATH}/travel/wallet/records`,
                title: 'رکوردهای کیف سفر',
                translateKey: 'رکوردهای کیف سفر',
                icon: 'Wallet1',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.travel.walletRecords.value],
                subMenu: [],
            },
            {
                key: 'travel/hotels/menu',
                path: `${APP_PREFIX_PATH}/travel/hotels`,
                title: 'هتل‌ها',
                translateKey: 'هتل‌ها',
                icon: 'RiHotelLine',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.travel.hotels.value],
                subMenu: [
                    {
                        key: 'travel/hotels',
                        path: `${APP_PREFIX_PATH}/travel/hotels`,
                        title: 'هتل‌ها',
                        translateKey: 'هتل‌ها',
                        icon: 'RiHotelLine',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.hotels.value],
                        subMenu: [],
                    },
                    {
                        key: 'travel/hotels/itineraries',
                        path: `${APP_PREFIX_PATH}/travel/hotels/itineraries`,
                        title: 'برنامه‌های هتل',
                        translateKey: 'برنامه‌های هتل',
                        icon: 'RiCalendarScheduleLine',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.hotelsItineraries.value],
                        subMenu: [],
                    },
                    {
                        key: 'travel/hotels/reservations',
                        path: `${APP_PREFIX_PATH}/travel/hotels/reservations`,
                        title: 'رزروهای هتل',
                        translateKey: 'رزروهای هتل',
                        icon: 'MdCardTravel',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.hotelsReservations.value],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'travel/tours/menu',
                path: `${APP_PREFIX_PATH}/travel/tours`,
                title: 'تور‌ها',
                translateKey: 'تورها',
                icon: 'MdOutlineTravelExplore',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.travel.tours.value],
                subMenu: [
                    {
                        key: 'travel/tours',
                        path: `${APP_PREFIX_PATH}/travel/tours`,
                        title: 'تورها',
                        translateKey: 'تورها',
                        icon: 'MdOutlineTravelExplore',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.tours.value],
                        subMenu: [],
                    },
                    {
                        key: 'travel/tours/itineraries',
                        path: `${APP_PREFIX_PATH}/travel/tours/itineraries`,
                        title: 'برنامه‌های تور',
                        translateKey: 'برنامه‌های تور',
                        icon: 'RiCalendarScheduleLine',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.toursItineraries.value],
                        subMenu: [],
                    },
                    {
                        key: 'travel/tours/reservations',
                        path: `${APP_PREFIX_PATH}/travel/tours/reservations`,
                        title: 'رزروهای تور',
                        translateKey: 'رزروهای تور',
                        icon: 'MdCardTravel',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.toursReservations.value],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'travel/accommodations/menu',
                path: `${APP_PREFIX_PATH}/travel/accommodations`,
                title: 'اقامتگاه‌ها',
                translateKey: 'اقامتگاه‌ها',
                icon: 'TcBeach',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.cultural.travel.accommodations.value],
                subMenu: [
                    {
                        key: 'travel/accommodations',
                        path: `${APP_PREFIX_PATH}/travel/accommodations`,
                        title: 'اقامتگاه‌ها',
                        translateKey: 'اقامتگاه‌ها',
                        icon: 'TcBeach',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.accommodations.value],
                        subMenu: [],
                    },
                    {
                        key: 'travel/accommodations/itineraries',
                        path: `${APP_PREFIX_PATH}/travel/accommodations/itineraries`,
                        title: 'برنامه‌های اقامتگاه',
                        translateKey: 'برنامه‌های اقامتگاه',
                        icon: 'RiCalendarScheduleLine',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.accommodationsItineraries.value],
                        subMenu: [],
                    },
                    {
                        key: 'travel/accommodations/reservations',
                        path: `${APP_PREFIX_PATH}/travel/accommodations/reservations`,
                        title: 'رزروهای اقامتگاه',
                        translateKey: 'رزروهای اقامتگاه',
                        icon: 'MdCardTravel',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.accommodationsReservations.value],
                        subMenu: [],
                    },
                ],
            },
            {
                key: 'travel/reports/menu',
                path: `${APP_PREFIX_PATH}/travel/reports/menu`,
                title: 'گزارشات',
                translateKey: 'گزارشات',
                icon: 'BiBarChartSquare',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [Permissions.support.reports.value],
                subMenu: [
                    {
                        key: 'travel/reports/usage',
                        path: `${APP_PREFIX_PATH}/travel/reports/usage`,
                        title: 'گزارش استفاده',
                        translateKey: 'گزارش استفاده',
                        icon: 'HiOutlineDocumentReport',
                        type: NAV_ITEM_TYPE_ITEM,
                        permissions: [Permissions.cultural.travel.reports.usage.value],
                        subMenu: [],
                    },
                ],
            },
        ],
    },
    {
        key: 'charity',
        path: `${APP_PREFIX_PATH}/charity`,
        title: 'خیریه',
        translateKey: 'خیریه',
        icon: 'LuHandHelping',
        type: NAV_ITEM_TYPE_TITLE,
        permissions: [Permissions.cultural.charity.value],
        subMenu: [
            {
                key: 'charity/campaigns',
                path: `${APP_PREFIX_PATH}/charity/campaigns`,
                title: 'پویش‌ها',
                translateKey: 'پویش‌ها',
                icon: 'MdOutlineCampaign',
                type: NAV_ITEM_TYPE_TITLE,
                permissions: [Permissions.cultural.charity.campaigns.value],
                subMenu: [],
            },
            {
                key: 'charity/empaths',
                path: `${APP_PREFIX_PATH}/charity/empaths`,
                title: 'همدلی‌ها',
                translateKey: 'همدلی‌ها',
                icon: 'TbEmpathize',
                type: NAV_ITEM_TYPE_TITLE,
                permissions: [Permissions.cultural.charity.empaths.value],
                subMenu: [],
            },
        ]
    }
]

export default culturalNavigationConfig
